import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

import { Scopes } from '../../api/types';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { RouteGuard } from '../../components/RouteGuard';

// Lazy-load the heavy pages (Recharts ships only when /dashboard is hit).
const DashboardPage = lazy(() =>
  import('./pages/DashboardPage').then((m) => ({ default: m.DashboardPage })),
);
const DocumentsListPage = lazy(() =>
  import('./pages/DocumentsListPage').then((m) => ({ default: m.DocumentsListPage })),
);
const RoiDashboardPage = lazy(() =>
  import('./pages/RoiDashboardPage').then((m) => ({ default: m.RoiDashboardPage })),
);
const BatchesPage = lazy(() =>
  import('./pages/BatchesPage').then((m) => ({ default: m.BatchesPage })),
);

function suspended(node: JSX.Element): JSX.Element {
  return (
    <Suspense
      fallback={
        <div className="flex justify-center py-12">
          <LoadingSpinner />
        </div>
      }
    >
      {node}
    </Suspense>
  );
}

/** Routes contributed by the Dashboard + Documents listing feature. */
export const dashboardRoutes: RouteObject[] = [
  {
    path: 'dashboard',
    element: (
      <RouteGuard scope={Scopes.DocumentsRead}>
        {suspended(<DashboardPage />)}
      </RouteGuard>
    ),
  },
  {
    path: 'dashboard/roi',
    element: (
      <RouteGuard scope={Scopes.DocumentsRead}>
        {suspended(<RoiDashboardPage />)}
      </RouteGuard>
    ),
  },
  {
    path: 'documents',
    element: (
      <RouteGuard scope={Scopes.DocumentsRead}>
        {suspended(<DocumentsListPage />)}
      </RouteGuard>
    ),
  },
  {
    path: 'batches',
    element: (
      <RouteGuard scope={Scopes.DocumentsWrite}>
        {suspended(<BatchesPage />)}
      </RouteGuard>
    ),
  },
];
